import axios from "axios";

async function permaDelete(url) {
    const result = await axios("/api/permaDelete?url=" + url);
    console.log(result.data);
}

export default permaDelete;
